import { clone } from "lodash-es";
import Vue from "vue";
import { mapActions } from "vuex";

import { Message } from "@/components/opportunity-snackbar/Message";
import { CookieService, StorageService, UserService } from "@/services";
import { Person } from "@/services/DTOs";
import store from "@/store/store";

const localeCookieDomain = process.env.VUE_APP_ROOT_DOMAIN || ".torre.ai";
const localeCookieName = "torre.locale";

declare module "vue/types/vue" {
  // tslint:disable-next-line interface-name
  interface Vue {
    appMixin_bioUrl: string;
    appMixin_selfUrl: string;
    appMixin_homepagesUrl: string;
    appMixin_vaderUrl: string;
    appMixin_saveUserLocale: (locale: string, authenticated: boolean) => void;
  }
}

export default Vue.extend({
  computed: {
    appMixin_bioUrl(): string {
      return process.env.VUE_APP_DISCOVERY_UI_BIO_URL || "";
    },
    appMixin_selfUrl(): string {
      return process.env.VUE_APP_DISCOVERY_UI_SELF_URL || "";
    },
    appMixin_homepagesUrl(): string {
      return process.env.VUE_APP_DISCOVERY_HOMEPAGES_URL || "";
    },
    appMixin_vaderUrl(): string {
      return process.env.VUE_APP_DISCOVERY_UI_VADER_URL || "";
    },
    userPublicId(): string {
      const user = store.state.users.authentication.user as Person;
      return user.publicId ?? user.username;
    }
  },
  methods: {
    // tslint:disable-next-line no-empty
    refreshUser: () => {},
    ...mapActions("users", ["refreshUser"]),
    appMixin_saveUserLocale(locale: string, authenticated: boolean = false) {
      if (authenticated) {
        UserService.updateLocale(this.userPublicId, locale).subscribe(
          () => {
            this.refreshUser();
            this.refreshUserLocale(locale);
          },
          () => {
            this.$root.$emit("flash-message", new Message(this.$t("Error updating language", locale) as string));
          }
        );
      } else {
        this.refreshUserLocale(locale);
      }
    },
    updateDocumentTitle(newLocale: string) {
      const currentLocale = this.$i18n.locale;
      const defaultTitle = "Torre | Let AI do the job hunting and recruitment for you";

      if (currentLocale !== newLocale) {
        const translatedTitle = this.$t(defaultTitle, newLocale) as string;
        document.title = translatedTitle;
      }
    },
    refreshUserLocale(locale: string) {
      StorageService.storeUserLocale(locale);
      CookieService.setCookie(localeCookieName, locale, 3000, localeCookieDomain);

      this.updateDocumentTitle(locale);
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
      }
      this.$router.push(clone(this.$route));
      this.$root.$emit("reload", locale);
    }
  }
});
